import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
    },
    panel: {
        height: '100%',
        overflow: 'hidden',
    },
    resizeHandle: {
        width: '4px',
        backgroundColor: tokens.colorNeutralStroke2,
        transitionProperty: 'background-color',
        transitionDuration: '150ms',
        ':hover': {
            backgroundColor: tokens.colorBrandStroke1,
        },
    },
});
